import React from 'react';
export class CnTabItem extends React.Component {
    static displayName = 'CnTabItem';
    render() {
        return <>{this.props.children}</>;
    }
}
